import { render } from "./ContactSimpleInfoCard.vue?vue&type=template&id=7ecb716b&scoped=true"
import script from "./ContactSimpleInfoCard.vue?vue&type=script&lang=js"
export * from "./ContactSimpleInfoCard.vue?vue&type=script&lang=js"

import "./ContactSimpleInfoCard.vue?vue&type=style&index=0&id=7ecb716b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecb716b"]])

export default __exports__